module.exports = __webpack_public_path__ + "static/media/icon_globe.7f31b69d.svg";